<template>
  <div>

    <van-nav-bar
        :title="navBarTitle"
        left-text="返回"
        right-text="首页"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        ></van-nav-bar>

    <div class="prompt">
        <div class="prompt-title">{{title}}</div>
        <div class="prompt-tip">{{tip}}</div>
    </div>
    <!-- 密码输入框 -->
    <van-password-input
        :value="password"
        :focused="showKeyboard"
        @focus="showKeyboard = true"
        info="密码为 6 位数字"
        :gutter="10"
        :error-info="errorInfo"
    />
    <div class="forgot"  @click="toForgotPassword">忘记直付密码？</div>
    <!-- 数字键盘 -->
    <van-number-keyboard
        v-model="password"
        :show="showKeyboard"
        @blur="showKeyboard = false"
    />
    <div class="box-btn">
        <van-button  size="large" color="#2176ff" @click="VerifyPassword">确定</van-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
  },
  data() {
        return {
            password: '',//密码、键盘值
            showKeyboard: false, //数字键盘显隐
            title: '设置直付密码',
            tip: '请设置直付密码，用于基金线上支付验证',
            onePassword: '',
            errorInfo:'',//错误提示词
            firstSet: true, //是否为第一次设置密码
            oldPwd: '',//原密码

            firstSetPwdFlag:'y',

            navBarTitle:"修改直付密码",
        };
    },
    //  // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //document.title = '设置直付密码';
    },    
    methods: {
        init(){
            // if(!this.$route.query.hasPwd){
                
            // }
            if(this.$route.query.hasPwd == 'y'){ //有密码则不为第一次设置密码
                console.log()
                this.firstSet = false;
                this.title = '修改直付密码';
                this.tip= '请输入原直付密码，以验证身份'

                this.navBarTitle = "修改直付密码";
            }else{
                this.firstSetPwdFlag ='y';
                this.navBarTitle = "设置直付密码";
            }
        },
        VerifyPassword(){ //校验
            if(this.password.length !== 6) return this.$toast.fail('请输入六位直付密码');
       
            if (!this.firstSet && !this.validatePwd()) return;//不是第一次设置密码，调用验证密码api
           
            if(this.onePassword){
                this.onePassword === this.password ? this.setPassword() : (this.errorInfo = '密码不一致，请重新输入', this.clearPassword());
                
            }else{
                this.title = '设置密码',
                this.tip = '请再次填写确认密码'
                this.onePassword = this.password
                this.password = ''
                this.errorInfo = ''
            }  
        },
        setPassword(){
            const requestData = {
                lysCstUserId: sessionStorage.getItem('lysCstUserId'),
                pwd: this.password
            };

            const apiEndpoint = this.firstSet ? 'firstSetPwd' : 'updatePwd';

            this.$getRequestData(apiEndpoint, requestData)
            .then(result => {
                if(result.resultCode === '0000'){

                    this.$dialog.alert({
                        title: '成功',
                        message: '设置新密码成功',
                        confirmButtonText: '返回首页',
                        theme: 'round-button'
                    }).then(() => {
                        this.$router.push({ path: '/index/homePage' });
                    });                    

                }
            });

        },
        clearPassword(){
            this.title = '设置新直付密码',
            this.tip = '请设置新直付密码，用于基金线上支付验证'
            this.onePassword = ''
            this.password = ''
        },
        validatePwd(){  //密码验证api
            console.log(this.password)
            this.$getRequestData('validatePwd', {lysCstUserId:sessionStorage.getItem('lysCstUserId'),pwd:this.password})
               .then(result => {
                   if(result.bizData.resutFlag == 'y'){
                    this.firstSet = true
                       this.clearPassword();
                       return true;
                   }else{
                       this.$dialog.alert({
                           message: '直付密码错误，请重试',
                           theme: 'round-button',
                           showCancelButton: true,
                           confirmButtonText: '重试',
                           cancelButtonText: '忘记直付密码',
                       }).then(() => {
                           // on close
                           this.password = ''
                       }) .catch(() => {
                           // on cancel
                           this.toForgotPassword()
                       });
                        return false
                   }

               })
        },
        toForgotPassword(){
            this.$router.push({ path: '/pay/forgotPassword' });
        },

        onClickLeft(){
            history.go(-1);
        },
        onClickRight()
        {
             this.$router.push({ path: '/' })
        }, 
    },
  computed: {},
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init()
  },

  
  // 生命周期 - 创建之前
  beforeCreate() {},
  // 生命周期 - 挂载之前
  beforeMount() {},
  // 生命周期 - 更新之前
  beforeUpdate() {},
  // 生命周期 - 更新之后
  updated() {},
  // 生命周期 - 销毁之前
  beforeDestroy() {},
  // 生命周期 - 销毁完成
  destroyed() {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>

<style lang="less" scoped>
//@import url(); 引入公共css类
.prompt {
    margin: 100px 20px 20px;
    .prompt-title {
        margin: 20px 0;
        font-weight: 600;
    }
    .prompt-tip {
        font-size: 14px;
    }
}
.van-password-input__security li {
    background-color: #EEEEEE;
}
.box-btn {
    margin-top: 80px;
    padding: 0 20%;
}
.forgot{
    margin: 10px 0;
    font-size: 15px;
}
</style>
